import moment from 'moment-timezone'

export const getMoment = () => moment().toISOString()

export const tag = _tagData => {
  if (!__APP_IS_PRODUCTION__) {
    return null
  }

  return null
  // return window.UST.tag(tagData)
}

export const event = _eventData => {
  if (!__APP_IS_PRODUCTION__) {
    return null
  }

  return null
  // return window.UST.event(eventData)
}
